export type RuleLevel = "Participant" | "Site" | "Trial";
export type RuleKind = "discrepancy" | "review_materiality" | "review_sla";

/** Structured definition for the non-SQL rule kinds. */
export type ReviewRuleConfig = {
  domain?: string;
  material_fields?: string[];
  administrative_fields?: string[];
  tier?: "sae" | "routine";
  hours?: number;
};
export type RuleSeverity = "Critical" | "Major" | "Minor";
export type RuleStatus = "draft" | "active" | "paused";

export type RuleRun = {
  id: number;
  trigger: string;
  sql_version: number;
  started_at: string;
  duration_ms: number | null;
  matched_count: number;
  new_count: number;
  resolved_count: number;
  open_count: number;
  status: string;
  error_message: string | null;
};

export type RuleDefinition = {
  id: number;
  core_rule_id: number;
  name: string;
  description: string | null;
  rule_kind: RuleKind;
  config: ReviewRuleConfig | null;
  config_version: number;
  level: RuleLevel;
  domain: string | null;
  severity: RuleSeverity;
  sql_text: string;
  sql_version: number;
  explanation: string | null;
  status: RuleStatus;
  origin: "Custom";
  created_by: string | null;
  created_at: string;
  updated_at: string;
  enabled_for_trial: boolean;
  enabled_trials: string[];
  open_count: number;
  last_run: RuleRun | null;
  runs?: RuleRun[];
  activation_run?: RunOutcome;
};

export type RunOutcome = {
  matched_count: number;
  new_count: number;
  resolved_count: number;
  open_count: number;
  duration_ms: number;
};

export type GenerateResult = {
  sql: string;
  explanation: string;
  tables: string[];
  name: string;
  domain: string;
};

export type TestResult = {
  columns: string[];
  rows: (string | number | boolean | null)[][];
  total_count: number;
  duration_ms: number;
  truncated: boolean;
  row_cap: number;
};

/** A system (ingested) rule row from the existing issue_rules endpoint. */
export type SystemRule = {
  discrepancy_rule_id: number;
  discrepancy_rule_data_source: string | null;
  discrepancy_rule_level: string | null;
  discrepancy_rule_type: string | null;
  discrepancy_rule_category: string | null;
  discrepancy_rule_subcategory: string | null;
  discrepancy_rule_description: string | null;
  discrepancy_rule_details: string | null;
  discrepancy_rule_vivo_status: string | null;
};

/** The id block reserved for definition mirrors in vivodb.discrepancy_rules —
 * mirrored rows are represented by their RuleDefinition, so the system list
 * must exclude them. Keep in sync with
 * DiscrepancyRuleDefinition.CORE_RULE_ID_BASE on the backend. */
export const CORE_RULE_ID_BASE = 900000;
